import type { AuditEventType } from "../../../models/audit/auditEvent";

/**
 * The log is monochrome by default; colour is reserved for the handful of
 * events whose outcome an auditor needs to spot without reading. Tones are
 * applied to the glyph only — never as a filled background — so the feed
 * stays quiet at a glance.
 */
export type AuditEventTone =
  | "neutral"
  | "positive"
  | "destructive"
  | "override";

const TONE_BY_EVENT_TYPE: Record<AuditEventType, AuditEventTone> = {
  test_created: "neutral",
  session_renamed: "neutral",
  session_deleted: "destructive",
  template_changed: "neutral",
  control_config_edited: "neutral",
  test_run: "neutral",
  sample_rerun: "neutral",
  cell_rerun: "neutral",
  column_rerun: "neutral",
  documents_rematched: "neutral",
  manual_override: "override",
  support_data_cell_edited: "neutral",
  walkthrough_step_edited: "neutral",
  walkthrough_verdict_edited: "override",
  walkthrough_citation_imported: "neutral",
  reperformance_step_added: "neutral",
  reperformance_step_edited: "neutral",
  reperformance_step_deleted: "destructive",
  sample_row_added: "neutral",
  sample_row_edited: "neutral",
  sample_row_deleted: "destructive",
  sample_upload_confirmed: "neutral",
  citation_added: "neutral",
  citation_updated: "neutral",
  citation_deleted: "destructive",
  citation_marked_key: "neutral",
  result_locked: "neutral",
  result_unlocked: "neutral",
  result_deleted: "destructive",
  evidence_added: "neutral",
  evidence_removed: "destructive",
  submitted_for_review: "neutral",
  approval_requested: "neutral",
  approval_approved: "positive",
  approval_rejected: "destructive",
  member_removed: "destructive",
};

const TONE_TEXT_CLASS: Record<AuditEventTone, string> = {
  neutral: "text-stone-500",
  positive: "text-emerald-600",
  destructive: "text-red-600",
  override: "text-midship-orange",
};

export function toneTextClass(eventType: AuditEventType): string {
  return TONE_TEXT_CLASS[TONE_BY_EVENT_TYPE[eventType]];
}
